import { FC, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { Checkbox, TextArea } from "capitalrx-components-2.0/lib/forms";

import { ANSWER_NOT_AVAILABLE } from "@/utils";

import { QuestionWrapper, QuestionnaireWrapperProps } from "./QuestionWrapper";
import styles from "../../ClinicalCriteria.module.scss";


interface Props extends QuestionnaireWrapperProps {
  readonly questionNote?: string;
  readonly renderAnswerChoicesOnly?: boolean;
}

export const Freeform: FC<Props> = ({
  name,
  isReadonly = false,
  questionNote,
  renderAnswerChoicesOnly = false,
  ...rest
}) => {
  const { setValue } = useFormContext();

  const [value, notAvailable] = useWatch({ name: [`${name}_value`, `${name}_not_available`] });

  useEffect(() => {
    const inputValue = notAvailable ? ANSWER_NOT_AVAILABLE : value;
    setValue(name, inputValue);
  }, [value, notAvailable, setValue, name]);

  const choices = (
    <TextArea.Field
      className={styles.FullWidth}
      name={`${name}_value`}
      label={questionNote}
      readOnly={isReadonly}
      disabled={notAvailable}
      hideLabel={!questionNote}
    />
  );

  let component = (
    <QuestionWrapper
      isReadonly={isReadonly}
      name={name}
      hideClearSelection
      {...rest}
    >
      {choices}
      <Checkbox.Field
        name={`${name}_not_available`}
        label="Answer not available"
        readOnly={isReadonly}
        hideLabel
      />
    </QuestionWrapper>
  );

  if (renderAnswerChoicesOnly) {
    component = choices;
  }
  return <>{component}</>;
};
